export const getBands = async () => {
    const resp = await fetch(
        `${process.env.REACT_APP_API_URL}/bands`
    );
    const data = await resp.json();
    return data;
};
